module.exports = __webpack_public_path__ + "static/img/rug_02.6a59c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rug_02.png
// module id = kHq6
// module chunks = 17